import React, { useEffect, useState } from 'react'
import { Alert, Checkbox, Input, Modal, Typography } from 'antd'

// 2026-10-20 coder(lq): 不做乐观写入；先展示前后值，再显式确认并填写审计原因。
export default function ChangeConfirm({ change, busy, onCancel, onSubmit }) {
    const [reason, setReason] = useState('')
    const [confirmed, setConfirmed] = useState(false)
    useEffect(() => { setReason(''); setConfirmed(false) }, [change])
    return <Modal title="确认权限配置变更" open={!!change} onCancel={busy ? undefined : onCancel}
        destroyOnClose confirmLoading={busy} closable={!busy} maskClosable={false} keyboard={!busy}
        okText="确认保存" cancelText="取消变更" width={780}
        okButtonProps={{ disabled: !confirmed || reason.trim().length < 2 }}
        onOk={() => onSubmit(reason.trim())}>
        {change && <>
            <Alert showIcon type="warning" message={change.warning || '关系和策略可能改变用户访问范围，请核对后再保存。'} />
            {change.summary && <ul className="menu-api-policy-summary" aria-label="系统开关变更摘要">
                {change.summary.map((line, index) => <li key={index}>{line}</li>)}
            </ul>}
            <details open={!change.summary}><summary>查看完整技术差异</summary><div className="menu-api-compare">
                <section><Typography.Title level={5}>修改前</Typography.Title><pre>{JSON.stringify(change.before, null, 2)}</pre></section>
                <section><Typography.Title level={5}>修改后</Typography.Title><pre>{JSON.stringify(change.after, null, 2)}</pre></section>
            </div></details>
            <label htmlFor="menu-api-change-reason">变更原因（必填）</label>
            <Input.TextArea id="menu-api-change-reason" value={reason} maxLength={255} rows={2}
                onChange={event => setReason(event.target.value)} placeholder="例如：已核对控制器，该接口应属于客户查询菜单" />
            <Checkbox checked={confirmed} onChange={event => setConfirmed(event.target.checked)}>
                我已核对修改前后差异和访问影响
            </Checkbox>
        </>}
    </Modal>
}
